import { createAction, createListenerMiddleware, type TypedStartListening } from '@reduxjs/toolkit';
import { getLogger } from 'app-components/utils/core';

import type { AppDispatch, RootState } from '../store';

const log = getLogger('storeListeners/listenerMiddleware');

export const listenerMiddleware = createListenerMiddleware();

export const initListeners = createAction('INIT_LISTENERS');

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening = listenerMiddleware.startListening as AppStartListening;

log.info('Listener middleware created');
